import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageSync, LocalizationProvider, ThemeProvider, ThemeSync } from './providers';
import { ProfileProvider } from './utils/ProfileService';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <LocalizationProvider>
    <ProfileProvider>
      <ThemeProvider>
        <ThemeSync />
        <LanguageSync />
        <App />
      </ThemeProvider>
    </ProfileProvider>
  </LocalizationProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
